
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bcks/pdf-preview",
      function () {
        return require("private-next-pages/bcks/pdf-preview.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bcks/pdf-preview"])
      });
    }
  